"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultCompare = void 0;
var React = require("react");
var App_1 = require("./App");
var Store_1 = require("./compare/Store");
var HomePage_1 = require("./compare/HomePage");
var CompareProducts_1 = require("./CompareProducts/CompareProducts");
var Actions_1 = require("./compare/Actions");
var ES6Promise = require("es6-promise");
require("isomorphic-fetch/fetch-npm-browserify");
//
// //var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
var SearchResultCompare = function (state) {
    state.favourites = (0, Actions_1.loadStateFromStorage)() || [];
    return React.createElement(Store_1.StoreProvider, { state: state },
        React.createElement(App_1.default, null,
            React.createElement(HomePage_1.default, null)));
};
exports.SearchResultCompare = SearchResultCompare;
global.SearchResultCompare = exports.SearchResultCompare;
global.CompareProducts = CompareProducts_1.CompareProducts;
exports.default = exports.SearchResultCompare;
